import React, { useContext } from 'react';
import { IfmsRoute } from '../../../config/types';
import { findSecurityTask } from '../../../util';
import ApplicationContext from '../../../ApplicationContext';
import { FmsSecTask } from '../../../fms.core/constants';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useJobMenu from '../../../hooks/useJobMenu';
import constants from '../../../constants';
import { JobNames } from '../../../framework.core/JobNames';
import ReportSchedulingView from '../reportScheduling/ReportSchedulingView';

export const CompanyView = React.lazy(() => import('../companies/CompanyView'));
const JobListView = React.lazy(() => import('../JobListView'));
const ReportViewer2 = React.lazy(() => import('../../../uiControls/ReportViewer2'));

const AgentStatementView = React.lazy(() => import('../../accounting/reports/AgentStatementView'));
const CustomerVendorViews = React.lazy(() => import('../../accounting/reports/CustomerVendorStatementView'));
const PickupDeliveryView = React.lazy(() => import('../../reports/PickupDeliveryView')); 
const ImporterBondQueryView = React.lazy(() => import('../../referenceFiles/implementation/codes/ImporterBondQueryView'));
const LastTransactionView = React.lazy(() => import('../../referenceFiles/implementation/codes/LastTransactionView'));
const MemoListView = React.lazy(() => import('../../reports/MemoListView'));
const CompanyAddressLabelView = React.lazy(() => import('../../reports/CompanyAddressLabelView'));
const CustomerActivityView = React.lazy(() => import('../../common/reports/CustomerActivityView'));
const InternetTrackingCustomerView = React.lazy(() => import('../../referenceFiles/implementation/codes/InternetTrackingCustomerView'));
const DeleteHistoryBLView = React.lazy(() => import('../../common/DeleteHistoryBLView'));
const DeleteHistoryBillingsView = React.lazy(() => import('../../common/DeleteHistoryBillingsView'));
const DeleteHistoryPaymentView = React.lazy(() => import('../../common/DeleteHistoryPaymentView'));
const CompanyTypeCodeView = React.lazy(() => import('../../setup/ifmsSetup/implementation/CompanyGroup'));
const ContainerTrackingUsageView = React.lazy(() => import('../reports/ContainerTrackingUsageView'));
const EmailTemplateView = React.lazy(() => import('../../Help/EmailTemplateView'));
const RecogHistoryView = React.lazy(() => import('../../common/RecogHistoryView'));

const getDeleteHistoryComponent = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const jobName = urlParams.get('jobname');
  
  const isBLMenu = jobName === JobNames.OIMbl || jobName === JobNames.OIHbl || jobName ===JobNames.OEMbl || jobName === JobNames.OEHbl || jobName === JobNames.AIMbl || jobName === JobNames.AIHbl || jobName === JobNames.AEMbl || jobName === JobNames.AEHbl || jobName === JobNames.OtherOP;
  const isPaymentMenu = jobName === JobNames.AllPayment || jobName === JobNames.CustPayment || jobName === JobNames.BillPayment || jobName === JobNames.CCPayment || jobName === JobNames.AgntPayment;

  if (isBLMenu) return DeleteHistoryBLView;
  if (isPaymentMenu) return DeleteHistoryPaymentView;
  
  return SecuredDeleteHistory;
};

// billings
const SecuredDeleteHistory: React.ComponentType<any> = (props: any) => {
  const urlParams = new URLSearchParams(window.location.search);
  const operation = urlParams.get('operation');
  const urlOperation = operation === constants.operations.warehousing ? constants.operations.warehousing : constants.List_Billings;

  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { goBack } = useJobMenu('Delete History', urlOperation, null, true, () => {});

  React.useEffect(() => {
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctCPayDeleteHistory);
    if (!listSec?.grantRead) {
      showGlobalOkDialog('Please check your user security!!!');
      goBack();
    }
  }, [appContext, showGlobalOkDialog, goBack]);

  return React.createElement(DeleteHistoryBillingsView, props);
};

// B/L, Payment
const DeleteHistoryView2: React.ComponentType<any> = (props: any) => {
  const Component = getDeleteHistoryComponent();
  return React.createElement(Component, props);
};

const routes: Array<IfmsRoute> = [
  { path: '/common/companies/:mode/:id?', component: CompanyView },
  // jobName (JobNames), opType (constants.opTypes)
  { path: '/common/joblistview/:jobName/:opType?', component: JobListView },
  //<pt220406: optab-rptviewer: Originating opType to show op menu (ifmsMain.operationFactory가 path에서 /opType을 찾는다)>
  { path: '/common/report/:args/:opType?', component: ReportViewer2 },
  { path: '/common/deleteHistory', component: DeleteHistoryView2 },
  { path: '/company/agentStatement', component: AgentStatementView },
  { path: '/company/customerVendor', component: CustomerVendorViews },
  { path: '/company/pickupDelivery', component: PickupDeliveryView },
  { path: '/company/importerBondQuery', component: ImporterBondQueryView },
  { path: '/company/lastTransaction', component: LastTransactionView },
  { path: '/company/memoList', component: MemoListView },
  { path: '/company/companyAddressLabel', component: CompanyAddressLabelView },
  { path: '/company/activeCustomer', component: CustomerActivityView },
  { path: '/company/internetTrackingCustomers', component: InternetTrackingCustomerView },
  { path: '/company/TypeCode', component: CompanyTypeCodeView },
  { path: '/common/recogHistory', component: RecogHistoryView },
  { path: '/shipmentStatus/cntrTrkUsage', component: ContainerTrackingUsageView },
  { path: '/utility/emailTemplate/:mode/:id?', component: EmailTemplateView },
  {path: '/shipmentStatus/reportScheduling/:mode/:id?', component: ReportSchedulingView},
];

export default routes;
